import { BehaviorSubject } from 'rxjs';
import { IPaymentInformationDTO, IPreTransactionByKeyPixDTO } from '../models/transaction.store.model';

export class TransactionStoreState {
  // PRIVATE PROPS
  // BehaviorSubject mantém o estado atual
  private prepareTransactionByKeyPixStateSubject = new BehaviorSubject<IPaymentInformationDTO | null>(null);
  private preTransactionByKeyPixStateSubject = new BehaviorSubject<IPreTransactionByKeyPixDTO | null>(null);

  private transactionStateSubject = new BehaviorSubject<any>(null);

  // PUBLIC PROPS
  public _prepareTransactionByKeyPixState$ = this.prepareTransactionByKeyPixStateSubject.asObservable();
  public _preTransactionByKeyPixState$ = this.preTransactionByKeyPixStateSubject.asObservable();

  public _transactionState$ = this.transactionStateSubject.asObservable();

  // CONSTRUCTOR
  constructor() {
    this.setPrepareTransactionByKeyPix(null);
    this.setPreTransactionByKeyPix(null);
  }

  // METHODS

  // METHODS SETTERS
  public setPrepareTransactionByKeyPix(newState: IPaymentInformationDTO | null) {
    this.prepareTransactionByKeyPixStateSubject.next(newState);
  }

  public setPreTransactionByKeyPix(newState: IPreTransactionByKeyPixDTO | null) {
    this.preTransactionByKeyPixStateSubject.next(newState);
  }

  public setTransaction(newState: any) {
    this.transactionStateSubject.next(newState);
  }

  // METHODS GETTERS
  public getPrepareTransactionByKeyPix(): IPaymentInformationDTO | null {
    return this.prepareTransactionByKeyPixStateSubject.getValue();
  }

  public getPreTransactionByKeyPix(): IPreTransactionByKeyPixDTO | null {
    return this.preTransactionByKeyPixStateSubject.getValue();
  }

  public getTransaction(): any {
    return this.transactionStateSubject.getValue();
  }
}
